// extracted by mini-css-extract-plugin
export default {"fees-modal":"style_fees-modal__1KzDL","feesModal":"style_fees-modal__1KzDL"};